import { Route, Routes } from "react-router-dom";

import CadastrarNovaSenha from "../pages/CadastrarNovaSenha";
import Login from "../pages/Login";
import NotFoundPage from "../pages/NotFoundPage";
import SolicitarNovaSenha from "../pages/SolicitarNovaSenha";

function AuthRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      {/* Link direto do e-mail de Ação nova no chamado (Regra CHA-033 do Raptor): sem sessão, a página do
          chamado mostra o login; depois dele o Portal troca para as rotas logadas na MESMA URL e abre o
          chamado. Antes caía em "Página Não Encontrada". */}
      <Route path="/app/chamados/:chamadoid" element={<Login />} />
      <Route path="/app/newpass" element={<SolicitarNovaSenha />} />
      <Route path="/app/changepass/:token" element={<CadastrarNovaSenha />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default AuthRoutes;
